import axios from "axios";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  TRANSLATION_LOADING,
  TRANSLATION_ADD,
  TRANSLATION_DELETE,
  TRANSLATION_FILTERS,
  TRANSLATION_LIST,
} from "./types";
import { requestCommonSearch } from "../common/requests";

const localeUrl = `${settings.localeUrl}api/`;
const ENDPOINT = "translation";

export const setLoading = (status) => ({
  type: TRANSLATION_LOADING,
  payload: status
});

export const translationAdd = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}`, data)
    .then(response => {
      dispatch({
        type: TRANSLATION_ADD,
        payload: response.data.content
      });
      callback(true);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const translationDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  axios
    .delete(`${localeUrl}${ENDPOINT}/${id}`)
    .then(() => {
      dispatch({
        type: TRANSLATION_DELETE,
        payload: {
          id
        }
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const translationGetFilters = () => dispatch => {
  dispatch(setLoading(true));
  axios
    .get(`${localeUrl}${ENDPOINT}/filters`)
    .then(response => {
      dispatch({
        type: TRANSLATION_FILTERS,
        payload: response.data.content
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const translationGetList = (criteria) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/list`, {
      criteria
    })
    .then(response => {
      dispatch({
        type: TRANSLATION_LIST,
        payload: response.data.content
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const translationGetSearch = (
  pageNumber = 0,
  pageSize = 10,
  sort = "id,ASC",
  criteria = [],
) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, pageNumber, pageSize, sort, criteria, localeUrl)
    .then(response => {
      dispatch({
        type: TRANSLATION_LIST,
        payload: response
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};



// WEBPACK FOOTER //
// ./src/actions/translation/requests.js